<template>
  <div class="ushk-backtop" :class="{'is-show': isShow}" @click="backtop">
    <a href="javascript:;" class="ushk-backtop__btn">
      <i class="ushk-icon ushk-icon_backtop"></i>
    </a>
  </div>
</template>
<script>
  import { debounce } from '@/commons/utils'
  export default {
    data () {
      return {
        isShow: false
      }
    },
    mounted () {
      document.addEventListener('scroll', debounce(this.scrollHandle, 10), false)
    },
    destroyed () {
      document.removeEventListener('scroll', this.scrollHandle, false)
    },
    methods: {
      scrollHandle () {
        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
        if (scrollTop > 200) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      },
      backtop () {
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame
        let move = window.scrollY
        let span = move / 15

        function step () {
          if (document.documentElement.scrollTop + document.body.scrollTop > 0) {
            if (document.body.scrollTop) {
              document.body.scrollTop -= 300
            } else {
              document.documentElement.scrollTop -= 300
            }
            requestAnimationFrame(step)
          } else {
  
          }
        }

        requestAnimationFrame(step)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Backtop.vue?536f0e14